import { ChangeDetectionStrategy, Component, DestroyRef, EventEmitter, inject, Input, Output, signal } from '@angular/core';
import { MapModeStateService } from '../map-mode-selection/map-mode-state.service';
import { MapModeSelectionComponent } from '../map-mode-selection/map-mode-selection.component';
import { QPointSuggestlistComponent, DropDownVariant, QPointSuggestlistValueTemplateDirective } from '@qpoint/forms';
import { CommonModule } from '@angular/common';
import { QPointMapModeConfiguration } from '../map-mode-selection/mode';

@Component({
    selector: 'qpoint-map-plant-suggestlist',
    imports: [
        CommonModule,
        QPointSuggestlistComponent,
        QPointSuggestlistValueTemplateDirective,
        MapModeSelectionComponent
    ],
    templateUrl: './map-plant-suggestlist.component.html',
    styleUrls: ['./map-plant-suggestlist.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MapPlantSuggestlistComponent {
  public plantsWithRoutesSignal = signal([]);
  public selectedPlantSignalId = signal<string>(null);
  public modes: QPointMapModeConfiguration[];
  destroyRef = inject(DestroyRef);
  @Input("plantsWithRoutes") set plantsWithRoutes (value: any[]) {
    this.plantsWithRoutesSignal.set(value);
  }
  @Input("selectedPlantId") set selectedPlant (value: any) {
    this.selectedPlantSignalId.set(value);
  }
  public dropDownVariant = DropDownVariant;

  constructor(
    public mapModeState: MapModeStateService
  ) {
  }

  @Output() plantChanged: EventEmitter<string> = new EventEmitter<string>();

  onPlantChanged(plantId: string) {
    this.plantChanged.emit(plantId);
  }
}
